module.exports = __webpack_public_path__ + "img/mainpro1.a41c3aa1.png";